import React from 'react';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';

const PrintDialogActions = ({
  onPrint,
  onClose,
  onShare,
  habilitaImagem,
  onToggleImagem
}) => (
  <Mui.DialogActions>
    <Mui.Box p={1} display="flex" alignItems="center">
      <Mui.FormControlLabel
        control={
          <Mui.Switch
            checked={habilitaImagem}
            onChange={(e) => onToggleImagem(e.target.checked)}
            color="primary"
          />
        }
        label={habilitaImagem ? 'Com imagem' : 'Sem imagem'}
      />
    </Mui.Box>

    <Mui.Box p={1}>
      <Mui.Button size="large" onClick={onShare}>
        Compartilhar
      </Mui.Button>
    </Mui.Box>

    <Mui.Box p={1}>
      <Mui.Button size="large" onClick={onPrint}>
        <MuiIcons.Print fontSize="small" />
        <span style={{ marginLeft: 10 }}>Imprimir</span>
      </Mui.Button>
    </Mui.Box>

    <Mui.Box p={1}>
      <Mui.Button size="large" onClick={onClose}>
        Cancelar
      </Mui.Button>
    </Mui.Box>
  </Mui.DialogActions>
);

export default PrintDialogActions;